import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-tai-chi-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga&exp=web_tai_chi_yoga_male_paywall_w_dynamic_line~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_tai_chi_yoga_male_paywall_w_dynamic_line'
					),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_tai_chi_yoga_male_paywall_w_dynamic_line~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_tai_chi_yoga_male_pr_paywall_w_dynamic_line'
					),
			},
		},
	},
]

export default config
